import { render, staticRenderFns } from "./EditBar.vue?vue&type=template&id=08f154d4&scoped=true&"
import script from "./EditBar.vue?vue&type=script&lang=js&"
export * from "./EditBar.vue?vue&type=script&lang=js&"
import style0 from "./EditBar.vue?vue&type=style&index=0&id=08f154d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f154d4",
  null
  
)

export default component.exports